import axiosInstance from "../axiosInstance";

export const fetch_cc_payment_by_id = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/admin/credit-card/history/${id}`);
    const payload = response?.data?.data;
    const payment =
      payload?.creditCardPayment ||
      payload?.payment ||
      payload?.utilityPayment ||
      payload;
    return {
      success: true,
      data: payment,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to load credit card bill payment",
      status: error.response?.status || 500,
      data: null,
    };
  }
};

export const admin_cc_refund = async (id, reason) => {
  try {
    const response = await axiosInstance.post(`/api/admin/credit-card/history/${id}/refund`, {
      reason,
    });
    return { success: true, data: response?.data?.data, message: response?.data?.message };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Refund failed",
      status: error.response?.status || 500,
    };
  }
};

export const admin_cc_retry_refund = async (id, reason = "retry") => {
  try {
    const response = await axiosInstance.post(
      `/api/admin/credit-card/history/${id}/refund/retry`,
      { reason }
    );
    return { success: true, data: response?.data?.data, message: response?.data?.message };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Refund retry failed",
      status: error.response?.status || 500,
    };
  }
};

export const admin_cc_reconcile = async (id, reason) => {
  try {
    const response = await axiosInstance.post(`/api/admin/credit-card/history/${id}/reconcile`, {
      action: "confirm_failed",
      reason,
    });
    return { success: true, data: response?.data?.data, message: response?.data?.message };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Reconcile failed",
      status: error.response?.status || 500,
    };
  }
};

export const fetch_cc_history= async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/admin/credit-card/history`,{
        params:params
    });
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
